import { ReactNode, useState } from 'react';

import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

/** The "View trace" toggle under a journey row; `children` is the trace body shown when open. */
export const TraceExpander = ({ children }: { children: ReactNode }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="flex gap-1 self-stretch pl-3">
      {/* Elbow connector from the row icon down to the trace toggle; shown collapsed too */}
      <div className="mb-2 w-3 shrink-0 self-stretch rounded-bl border-b border-l border-foreground-muted opacity-50" />
      <div className="flex min-w-0 flex-1 flex-col items-start">
        {isOpen && (
          <div className="flex items-start justify-between gap-4 self-stretch py-2 pr-0 pl-8">
            {children}
          </div>
        )}
        <div className="flex h-8 items-end">
          <Button
            variant="ghost-neutral"
            size="sm"
            onClick={() => setIsOpen(!isOpen)}
            aria-expanded={isOpen}
            className="h-auto min-w-0 gap-2 rounded-none p-0 text-sm leading-none font-medium text-foreground-muted hover:bg-transparent"
          >
            {isOpen ? <ChevronUpIcon size={16} /> : <ChevronDownIcon size={16} />}
            {t(
              isOpen
                ? 'campaigns.subscriber_journey.hide_trace'
                : 'campaigns.subscriber_journey.view_trace'
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};
